<template>
  <div class="partner-form">
    <el-dialog title="我要成为城市代理商" :visible.sync="visbility" center>
      <el-form
        :model="partnerForm"
        :rules="rules"
        ref="partnerForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="您的姓名" prop="username">
          <el-input v-model="partnerForm.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="partnerForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="city">
          <el-input v-model="partnerForm.city"></el-input>
        </el-form-item>

        <el-form-item label="公司类型" prop="companyKind">
          <el-radio-group v-model="partnerForm.companyKind">
            <el-radio v-model="partnerForm.companyKind" label="1">个人（个体工商户）</el-radio>
            <el-radio v-model="partnerForm.companyKind" label="0">非个人</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="经营范围" prop="saleRange">
          <el-input v-model="partnerForm.saleRange"></el-input>
        </el-form-item>
        <el-form-item label="年销售额" prop="yearSalemoney">
          <el-input v-model="partnerForm.yearSalemoney">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="是否在经营配送业务" prop="isManage">
          <el-radio-group v-model="partnerForm.isManage">
            <el-radio v-model="partnerForm.isManage" label="1">是</el-radio>
            <el-radio v-model="partnerForm.isManage" label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="图片验证" prop="captcha">
          <el-input v-model="partnerForm.captcha" style="width:200px;"></el-input>
          <img :src="captchaSrc" />
          <i class="el-icon-refresh" @click="refresh"></i>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="commit">提交资料</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinsVerification } from "@/mixins/verification";
export default {
  name: "partnerForm",
  props: {
    dialogVisbility: Boolean
  },
  mixins: [mixinsVerification],
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的手机号码"));
      }
      callback();
    };
    var checkYearSalemoney = (rule, value, callback) => {
      if (isNaN(value) || value < 1) {
        return callback(new Error("请输入正确的年销售额"));
      }
      callback();
    };
    var checkCity = (rule, value, callback) => {
      const cityArr = [
        "衡阳",
        "苏州",
        "武汉",
        "石家庄",
        "重庆",
        "宁波",
        "绵阳",
        "南京",
        "合肥",
        "深圳",
        "天津",
        "南昌",
        "常州",
        "广州",
        "杭州",
        "北京",
        "厦门",
        "福州",
        "东莞",
        "长沙",
        "贵阳",
        "上海",
        "沈阳",
        "青岛",
        "大连",
        "济南",
        "西安",
        "郑州",
        "成都",
        "温州",
        "无锡",
        "佛山",
        "赣州"
      ];
      if (cityArr.includes(value)) {
        return callback(new Error("该城市为美菜自营城市"));
      }
      if (!/^[\u4e00-\u9fa5]*$/.test(value)) {
        return callback(new Error("请输入正确的城市"));
      }
      callback();
    };
    return {
      visbility: this.dialogVisbility,
      partnerForm: {
        username: "",
        mobile: "",
        city: "",
        companyKind: "",
        saleRange: "",
        yearSalemoney: "",
        isManage: "",
        captcha: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入您的姓名", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ],
        city: [
          { required: true, message: "请输入所在城市", trigger: "blur" },
          { validator: checkCity, trigger: "blur" }
        ],
        companyKind: [
          { required: true, message: "请选择公司类型", trigger: "blur" }
        ],
        saleRange: [
          { required: true, message: "请填写经营范围", trigger: "blur" }
        ],
        yearSalemoney: [
          { required: true, message: "请填写年销售额", trigger: "blur" },
          { validator: checkYearSalemoney, trigger: "blur" }
        ],
        isManage: [
          { required: true, message: "请选择是否经营配送业务", trigger: "blur" }
        ],
        captcha: [
          { required: true, message: "请输入图片验证码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    commit() {
      this.$refs.partnerForm.validate(valid => {
        if (valid) {
          let captcha = this.partnerForm.captcha;
          let pramas = Object.assign({}, this.partnerForm);
          delete pramas.captcha;
          _api.all.createCityPartner(pramas, { captcha }).then(res => {
            this.visbility = false;
            this.refresh();
            this.$message({
              message: "提交信息成功",
              type: "success"
            });
            this.$refs.partnerForm.resetFields();
          });
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    visbility(val) {
      this.$emit("update:dialogVisbility", val);
    },
    dialogVisbility(val) {
      this.visbility = val;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
<style lang="scss">
.partner-form {
  .el-dialog {
    width: 800px !important;
    border-radius: 8px;
    .el-dialog__header {
      height: 120px;
      line-height: 100px;
      background: url(~@/assets/images/partner/t-line.png) no-repeat left bottom;
      .el-dialog__title {
        font-size: 30px;
      }
      .el-dialog__close {
        padding: 25px 20px 0 0;
        font-size: 36px;
      }
    }
    .el-dialog__body {
      text-align: initial;
      padding: 25px 150px 30px;
      .el-icon-refresh {
        font-size: 20px;
      }
    }
    .el-button {
      width: 280px;
      background: #64bd89;
    }
  }
}
</style>

